import { useEffect, useState } from "react";
import DependentList from "./baraemAddChild/DependentList";
import DevelopmentHistory from "./baraemAddChild/DevelopmentHistory";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllChild } from "../../services/liferay/baraemServices";
import { calculateAdjustedAgeInMonths, getLayoutDirection, isMobileApp } from "../../utils/util";
import { Loader } from "../../common/Loader";

const BaraemDashboard = ({ translationMap }) => {
  const location = useLocation();
  const { childAddError, childUpdateStatus } = location.state || false;
  const [selectedChild, setSelectedChild] = useState(null);
  const [allChildList, setAllChildList] = useState([]);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [chronologicalAgeMonths, setChronologicalAgeMonths] = useState(0);
  const [selectedChildId, setSelectedChildId] = useState(0);

  const navigate = useNavigate();


  useEffect(() => {
    window.parent.scrollTo(0, 0);

    const fetchChild = async () => {
      try {
        setIsApiLoading(true);


        const allChild = await getAllChild();

        if (allChild.status === 200) {
          setIsApiLoading(false);
          setAllChildList(allChild.data.data || []);
          setSelectedChild(allChild.data.data[0] || null);
          setSelectedChildId(allChild.data.data[0]?.childId || 0);
          if (allChild?.data?.data[0]?.childId) {
            setChronologicalAgeMonths(calculateAdjustedAgeInMonths(allChild.data.data[0].dob, allChild.data.data[0].prematurity));
          }


        }

      } catch (err) {
        setIsApiLoading(false);
        console.error(err);
      }
    };

    fetchChild();
  }, []);


  const handleChildSelection = (child) => {
    setSelectedChild(child);
    setChronologicalAgeMonths(calculateAdjustedAgeInMonths(child.dob, child.prematurity));
    setSelectedChildId(child.childId || 0);

  };
  if (isApiLoading) {
    return (
      <Loader />);

  }
  return (

    <div className={` custombody_color ${getLayoutDirection()}`}>


            <section className="w-100 clearfix BaraemMainSection" id="CoverPlanActive" style={{
        marginTop: "30px"
      }}>
                <div className="container customContainer">
                 {!isMobileApp() && <div className="Title_Inner_Box">
                        <h1 className="MainTitleOne">
                            {translationMap?.baraem ?? "Bara’em"}
                        </h1>
                    </div>
          }
                    {childAddError &&
          <div className="AlertInnerBox YellowAlertInnerBox alert alert-dismissible mt-3 mb-2 fade show">
                            <button type="button" className="close" data-dismiss="alert">&times;</button>
                            <div className="Icon_box">
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                <a href="javascript:void(0);">
                                    <span className="material-symbols-outlined">
                                        warning
                                    </span>
                                </a>
                            </div>
                            <div className="alert_text">
                                <h6>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);">
                                        {translationMap?.unableToAddChild}
                                    </a>
                                </h6>
                                <p className="number_txt">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);">
                                        {translationMap?.assessmentAgeOlderThanRange}
                                    </a>
                                </p>
                            </div>
                        </div>
          }

                    <div className={`cover_inner_wrapper ${allChildList.length > 1 ? 'cover_inner_wrapper_col_rev' : ''}`}>
                        <div className="cover_main_box1">
                            {childUpdateStatus &&
              <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                                    <button type="button" className="close" data-dismiss="alert">&times;</button>
                                    <div className="Icon_box">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                        <a href="javascript:void(0);">
                                            <span className="material-symbols-outlined">
                                                check_circle
                                            </span>
                                        </a>
                                    </div>
                                    <div className="alert_text">
                                        <h6>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                            <a href="javascript:void(0);">
                                                {translationMap?.childProfileUpdated}
                                            </a>
                                        </h6>
                                    </div>
                                </div>}
                            <div className="baraem_main_inner_wrapper baraem_main_inner_wrapper2">
                                <div className="baraem_dependent_list_box baraem_dependent_list_box_mr" style={{}}>
                                    <DependentList dependents={allChildList} onChildSelect={handleChildSelection}
                  isApiLoading={isApiLoading} translationMap={translationMap} selectedChildId={selectedChildId} />
                                    {selectedChild && <DevelopmentHistory selectedChild={selectedChild}
                  translationMap={translationMap} chronologicalAgeMonths={chronologicalAgeMonths} />
                  }
                                </div>
                            </div>
                        </div>
                        <div className="cover_main_box2">
                            <div className="inner_content_box inner_content_box_shadow">
                                <div className="top_title_box">
                                    <h6 className="MainTitleOne">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                        <a href="javascript:void(0);">
                                            {translationMap?.wantToAddChild}
                                        </a>
                                    </h6>
                                </div>
                                <div className="btn_box">
                                    <button onClick={() => navigate("/addChild")} className="blue_btn_link">
                                        {translationMap?.addChild}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </div>);





};

export default BaraemDashboard;